import React, { useState, useEffect } from "react"; import { useLocation } from '@reach/router';
import * as SunCalc from 'suncalc';

const Weather = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('https://api.weather.gov/gridpoints/HGX/57,107/forecast/hourly'); // Replace with your API endpoint
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        setData(result);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []); // Empty dependency array ensures this runs only once on mount


  // if (loading) return <p>Loading data...</p>;
  if (error) return <p>Error: {error.message}</p>;

  // get today's sunlight times for London
  var times = SunCalc.getTimes(new Date(), 30.06145603439729, -95.49565944146424);


  return (
    <div className="w-60 -mt-8 mb-4 mx-auto md:ml-0">
      <div className="mb-1 text-center">TODAY AT THE PARK</div>
      <div className="w-60 h-20 border-2 border-white bg-bggreen rounded-3xl bg-bggreen flex overflow-hidden text-2xl">
        <div className="w-full flex flex-col">
          <div className="w-full h-full flex justify-center items-center bg-bggreen text-white uppercase">

            {new Date().toLocaleString('en-US', { month: 'short' })}

          </div>
          <div className="bg-white w-full h-full flex justify-center text-bggreen items-center">

            {new Date().getDate()}

          </div>
        </div>
        <div className="border-x-2 bg-white border-bggreen text-bggreen w-full flex justify-center items-center">

          {data?.properties.periods["0"].temperature}°F

        </div>
        <div className="w-full flex flex-col text-[0.6rem]">
          <div className="relative bg-white w-full h-full overflow-hidden flex flex-col justify-start text-center text-bggreen">

            <div className="leading-none w-full pt-1">SUNRISE</div>
            <div className="leading-none w-full">{times.sunrise.toLocaleTimeString()}</div>

            <div className="absolute -bottom-3 left-1/2 -ml-3 rounded-full bg-bggreen w-6 h-6"></div>
          </div>
          <div className="relative w-full h-full overflow-hidden flex flex-col justify-end bg-bggreen text-center text-white">

            <div className="leading-none w-full">SUNSET</div>
            <div className="leading-none w-full pb-1">{times.sunset.toLocaleTimeString()}</div>

            <div className="absolute -top-3 left-1/2 -ml-3 rounded-full bg-white w-6 h-6"></div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Weather
